import { useState, useRef } from 'react';
import { IconButton, Popper, Paper, Slider, Stack, Typography, ClickAwayListener, Grow } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { useVolume } from '../../contexts/VolumeContext';

const SettingsButton = () => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);
    const { volume, setVolume } = useVolume();

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div>
                <IconButton
                    ref={anchorRef}
                    onClick={() => setOpen((prev) => !prev)}
                    sx={{
                        color: '#c191ff',
                        border: '1px solid rgba(193, 145, 255, 0.4)',
                        borderRadius: 1,
                        padding: '4px',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            borderColor: '#c191ff',
                            backgroundColor: 'rgba(193, 145, 255, 0.1)',
                        },
                    }}
                >
                    <SettingsIcon sx={{ fontSize: '1.1rem' }} />
                </IconButton>

                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-end"
                    transition
                    sx={{ zIndex: 1300 }}
                >
                    {({ TransitionProps }) => (
                        <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
                            <Paper
                                sx={{
                                    backgroundColor: '#1a2340',
                                    border: '1px solid rgba(193, 145, 255, 0.3)',
                                    borderRadius: 2,
                                    p: 2,
                                    mt: 1,
                                    minWidth: 200,
                                }}
                            >
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    {volume === 0 ? (
                                        <VolumeOffIcon sx={{ color: '#c191ff', fontSize: '1.2rem' }} />
                                    ) : (
                                        <VolumeUpIcon sx={{ color: '#c191ff', fontSize: '1.2rem' }} />
                                    )}
                                    <Slider
                                        value={volume}
                                        onChange={(_, val) => setVolume(val as number)}
                                        min={0}
                                        max={1}
                                        step={0.01}
                                        sx={{
                                            color: '#c191ff',
                                            '& .MuiSlider-thumb': {
                                                width: 14,
                                                height: 14,
                                                '&:hover, &.Mui-focusVisible': {
                                                    boxShadow: '0 0 8px rgba(193, 145, 255, 0.4)',
                                                },
                                            },
                                            '& .MuiSlider-track': {
                                                height: 4,
                                            },
                                            '& .MuiSlider-rail': {
                                                height: 4,
                                                opacity: 0.3,
                                            },
                                        }}
                                    />
                                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', minWidth: 30, textAlign: 'right' }}>
                                        {Math.round(volume * 100)}%
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </ClickAwayListener>
    );
};

export default SettingsButton;
